import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import moment from "moment";
import { useRef, useState } from "react";
import { ScreenRecorderHookProps } from "./useScreenRecorder";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { VideoShareException } from "./ScreenRecorderVideoShareException";
import { ActionButtons } from "./ScreenRecorderResultActionButtons";
import ScreenShareVIdeoShare from "./ScreenShareVIdeoShare";
import { useMenu } from "hook/useMenu";
import { getRoleId } from "utils/lastPathUtil";
import { DefaultQueryParam } from "api/interfaces/commonInterface.interface";

type ScreenRecorderResultType = {
  hookProps: ScreenRecorderHookProps;
  onFinish: () => void;
};

export function ScreenRecorderResult({
  hookProps,
  onFinish,
}: ScreenRecorderResultType) {
  const { queryNavigate } = useMenu({});
  const {
    resultBlob: blob,
    resultBlobUrl: blobUrl,
    startedAt,
    fileExtension,
  } = hookProps;
  const downloadRef = useRef<HTMLAnchorElement>(null);
  const [isInProgress, setIsInProgress] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [isUploadVideoShare, setIsUploadVideoShare] = useState<boolean>(false);
  const account: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  if (!blobUrl || !blob) {
    return (
      <BigPopupTemplate title="Recording Result" onModal={onFinish}>
        <p>Something went wrong - no blob</p>
      </BigPopupTemplate>
    );
  }

  const startedAtInFormat = moment(startedAt)
    .format("MM_DD_YYYY-h_mm_ssa")
    .toUpperCase();
  const fileName = `Recorded-${startedAtInFormat}.${fileExtension}`;

  function download() {
    if (!downloadRef.current) {
      return;
    }
    downloadRef.current.click();
  }

  function sendToTechSupport() {
    const searchParams = new URLSearchParams();
    searchParams.append("bloburl", blobUrl);
    searchParams.append("filename", fileName);
    queryNavigate({
      to: "/help/techsupport",
      queryInfo: {
        bloburl: blobUrl,
        filename: fileName,
        r: getRoleId() as string,
      } as unknown as DefaultQueryParam,
    });
    onFinish();
  }

  function returnToResultView() {
    setIsInProgress(false);
    setIsError(false);
  }

  if (isUploadVideoShare) {
    return (
      <ScreenShareVIdeoShare
        hookProps={hookProps}
        fileName={fileName}
        setIsUploadVideoShare={(finish) => {
          if (finish) {
            onFinish();
          }
          setIsUploadVideoShare(false);
        }}
      />
    );
  }

  return (
    <BigPopupTemplate title="Recording Result" onModal={onFinish}>
      <video src={blobUrl} controls autoPlay loop width="600" />
      <a ref={downloadRef} href={blobUrl} download={fileName}></a>
      <ActionButtons
        isInProgress={isInProgress}
        accountLevel={account.accountLevel}
        download={download}
        uploadToVideoShare={() => setIsUploadVideoShare(true)}
        sendToTechSupport={sendToTechSupport}
      />
      {!!isError && <VideoShareException onClose={returnToResultView} />}
    </BigPopupTemplate>
  );
}
